import React from "react";
import ModalFormCliente from "./ModalFormCliente";

const ModalCliente = ({ show, handleClose, cliente }) => {
  return (
    <ModalFormCliente show={show} handleClose={handleClose} cliente={cliente} />
  );
};

export default ModalCliente;

